import React from "react";
import PropTypes from "prop-types";
import UserNameField from "components/Field/UserNameField";
import FirstNameField from "components/Field/FirstNameField";
import LastNameField from "components/Field/LastNameField";
import PasswordAndConfirmField from "components/Field/PasswordAndConfirmField";
import PasswordField from "components/Field/PasswordField";

export const fieldTypes = {
  userName: "USERNAME",
  firstName: "FIRSTNAME",
  lastName: "LASTNAME",
  password: "PASSWORD",
  passwordAndConfirm: "PASSWORD_AND_CONFIRM",
};

export const fieldsTimeOutValue = 300;

const Field = ({ type, propsObject }) => {
  let SpecificField;
  switch (type) {
    case fieldTypes.userName:
      SpecificField = UserNameField;
      break;
    case fieldTypes.firstName:
      SpecificField = FirstNameField;
      break;
    case fieldTypes.lastName:
      SpecificField = LastNameField;
      break;
    case fieldTypes.password:
      SpecificField = PasswordField;
      break;
    case fieldTypes.passwordAndConfirm:
      SpecificField = PasswordAndConfirmField;
      break;
    default:
      return null;
  }

  return <SpecificField {...propsObject} />;
};

export default Field;

Field.propTypes = {
  type: PropTypes.string.isRequired,
  // props can be of any type, actual type checking is handled in the specific Dropdown components
  // eslint-disable-next-line react/forbid-prop-types
  propsObject: PropTypes.objectOf(PropTypes.any).isRequired,
};
